import { action, observable, computed } from 'mobx';
import URLS from '../../constant/urls';
import countryCodeVerify from '../../utils/countryCodeVerify';
import { InputTelephoneNumStoreModel } from '.';
import {fetch} from '../../utils/fetch'
class Telephone {
    @observable
    public countryCode = '86';

    @observable
    public telephoneNum = '';

    @observable
    public verificationValue = '';

    @observable
    public isMsgSentWaiting = false;
    public rootStore: InputTelephoneNumStoreModel;

    @observable
    public isShowTimePicker = false;

    @observable
    public currentSelectYear = new Date().getFullYear();

    @observable
    public tempSelectYear = new Date().getFullYear();

    public constructor(rootStore: InputTelephoneNumStoreModel) {
        this.rootStore = rootStore;
    }

    @computed
    public get buttonDisable() {
        return !countryCodeVerify(this.countryCode, this.telephoneNum) || this.isMsgSentWaiting;
    }

    @computed
    public get confirmDisable() {
        return (
            !countryCodeVerify(this.countryCode, this.telephoneNum) ||
            this.verificationValue.length === 0
        );
    }

    @action
    public updateCountryCodeValue = (val: string) => {
        this.countryCode = val;
    };

    @action
    public updateTelephoneValue = (val: string) => {
        this.telephoneNum = val;
    };

    @action
    public updateVerificationValue = (val: string) => {
        this.verificationValue = val;
    };

    @action
    public updateIsMsgSentWaiting = (bool: boolean) => {
        this.isMsgSentWaiting = !!bool;
    };

    public fetchVCodeSendData = async () => {
        const { countryCode, telephoneNum } = this;

        const option = {
            url: URLS.sendMobileCode,
            method: 'POST',
            requestType: 'form',
            body: {
                phone: telephoneNum,
                country: countryCode
            }
        };
        const response = fetch(option);
        return response;
    };

    public fetchVCodeValidateData = async () => {
        const { countryCode, telephoneNum, verificationValue } = this;

        const option = {
            url: URLS.verifyMobileCode,
            method: 'POST',
            requestType: 'form',
            body: {
                phone: telephoneNum,
                country: countryCode,
                vcode: verificationValue
            }
        };
        return fetch(option);
    };

    public resetTimePicker = ()=>{
        this.tempSelectYear = new Date().getFullYear();
        this.currentSelectYear = new Date().getFullYear();
    }
}
import { format } from 'url';

export default Telephone;
